// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-page__container[data-v-06cdee2d]{align-items:center;background-attachment:fixed!important;background-image:url(/backgrounds/brandimagery-loadsure-xl.webp)!important;background-position:50%!important;background-size:cover!important;display:flex;flex-direction:column;gap:20px;height:100vh;justify-content:center;width:100%}.loading-page__info[data-v-06cdee2d]{color:#fff;font-weight:500;max-width:330px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
